export default {
    methods: {
        navigate(path) {
            this.$router.push(path)
        },
    }
}